"use client";

import React, { Suspense } from "react";
import UspRoadmap from "@/components/newPageComponent/usp/UspRoadmap";
import UspBlogs from "@/components/newPageComponent/usp/UspBlogs";
import UspSTEMPathwayMobile from "@/components/newPageComponent/usp/UspSTEMPathwayMobile";
import UspAnnualSavingsMobile from "@/components/newPageComponent/usp/UspAnnualSavingsMobile";
import UspBannerMobile from "@/components/newPageComponent/usp/UspBannerMobile";
import USPPoweredByMobile from "@/components/newPageComponent/usp/USPPoweredByMobile";
import QuickContact from "@/components/common/QuickContact";
import UspFaq from "@/components/newPageComponent/usp/UspFaq";
import EventTicker from "@/components/common/EventTicker";
import UspHugeShortageMobile from "@/components/newPageComponent/usp/UspHugeShortageMobile";
import UspSolutionMobile from "@/components/newPageComponent/usp/UspSolutionMobile";
import UspAlumniUSMobile from "@/components/newPageComponent/usp/UspAlumniUSMobile";
import MilesAppStripDownload from "@/components/pageComponent/accountant/MilesAppStripDownload";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import StickyFooterLabel from "@/components/newPageComponent/CommonSection/StickyFooterLabel";
import { SectionSkeleton } from "@/components/common/LoadingSkeleton";

const MobilePage: React.FC = () => {
  return (
    <div className="w-full ">
      <MilesAppStripDownload />
      <div className="bg-[#191919] w-full blue_shadow z-[99]">
        <div className="w-full">
          <EventTicker />
        </div>
        <GlobalHeaderNew />
      </div>
      <UspBannerMobile />
      <UspHugeShortageMobile />
      <UspSolutionMobile />
      <UspSTEMPathwayMobile />
      <UspAnnualSavingsMobile />
      <UspRoadmap />
      <UspAlumniUSMobile />
      <UspBlogs />
      <USPPoweredByMobile />
      <UspFaq />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <Suspense fallback={<SectionSkeleton />}>
        <StickyFooterLabel pageName="USP" />
      </Suspense>
      <QuickContact />
    </div>
  );
};

export default MobilePage;
